// extracted by mini-css-extract-plugin
export default {"noFavorites":"styles_noFavorites__zFjl5","noFavoritesText":"styles_noFavoritesText__oyhhe"};